import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const initialisationStatusReducer = (state = false, action) => {
	switch (action.type) {
		case actionTypes.INITIALISATION_START:
			return true

		case actionTypes.INITIALISATION_ERROR:
		case actionTypes.INITIALISATION_COMPLETE:
			return false

		default:
			return state
	}
}

export default combineReducers({
	initialising: initialisationStatusReducer,
})

export const getInitialisationStatus = state => state.initialising
